module.exports = __webpack_public_path__ + "assets/img/20_53.ee4cac55.jpg";